import moment from 'moment';
import _ from 'lodash';
import uuidV4 from 'uuid/v4';

export const initialValues = {
  id: '',
  nome: '',
  nominativo: '',
  cognome: '',
  ragioneSociale: '',
  sdi: '',
  formaGiuridica: 'PF',
  comuneNascita: '',
  provinciaNascita: '',
  dataNascita: '',
  sesso: '',
  statoCivile: null,
  cittadinanza: {},
  anniInItalia: 0,
  codicefiscale: '',
  indirizzi: [],
  recapiti: [],
  partitaiva: '',
  telefono: [],
  email: [],
  anagraficheDisabilitate: [],
  'privacy.privacy': true,
  'privacy.marketing': false,
  'privacy.profilazione': false,
  'privacy.consensoInvioEmail': false,
  dettaglioProvenienza: '',
  dettaglioCollaboratore: '',
  dettaglioCoordinatore: '',
  dettaglioResponsabileArea: '',
  dettaglioInternoKiron: '',
  domicilioDiversoDaResidenza: 'false',
  provenienzaTecnocasa: '',
  provenienza: '',
  emailFattura: '',
  collaboratore: '',
  allegatoPrivacy: '',
  numeroPratiche: 0,
  note: [],
  userAcl: null,
  allegatoIdentitaData: {},
  allegatoCodiceFiscale: '',
  allegatoIdentita: '',
  codiceL3: '',
  codicefiscaleForzato: 0,
  liveIdRequests: [],
  appointment: {},
  createdFrom: 'campus web',
  codiceFiscaleLegaleRappresentante: null,
  nomeTitolareEffettivo: '',
  cognomeTitolareEffettivo: '',
  dataNascitaTitolareEffettivo: '',
  sessoTitolareEffettivo: '',
  comuneNascitaTitolareEffettivo: '',
  provinciaNascitaTitolareEffettivo: '',
  codicefiscaleTitolareEffettivo: '',
  cittaRegistroImprese: '',
  provinciaRegistroImprese : '',
  numeroRegistroImprese: '',
  allegatoVisuraCamerale: '',
  allegatoIdentitaTitolareEffettivo: '',
  allegatoIdentitaTitolareEffettivoData: {},
  allegatoCodiceFiscaleTitolareEffettivo: '',
  allegatoPrivacyTitolareEffettivo: '',
};

export const mapToInitialValues = (newValues, provenienzeOptions) => ({
  id: newValues.id,
  collaboratore: newValues.collaboratore || '',
  nome: newValues.nome || '',
  cognome: newValues.cognome || '',
  nominativo: newValues.nominativo || '',
  formaGiuridica: newValues.formaGiuridica || '',
  comuneNascita: newValues.comuneNascita || '',
  ragioneSociale: newValues.ragioneSociale || '',
  sdi: newValues.sdi || '',
  provinciaNascita: newValues.provinciaNascita || '',
  dataNascita: newValues.dataNascita ? moment.unix(newValues.dataNascita) : '',
  sesso: newValues.sesso || '',
  provenienza:
    provenienzeOptions &&
    _.find(provenienzeOptions.options, (o) => o.value === _.get(newValues, '_embedded.provenienza.id', '')),
  statoCivile: newValues.statoCivile || '',
  cittadinanza: newValues.cittadinanza ? { value: newValues.cittadinanza, label: newValues.cittadinanza } : '',
  anniInItalia: newValues.anniInItalia || '',
  codicefiscale: newValues.codicefiscale || '',
  indirizzi: newValues._embedded.indirizzi || [],
  partitaiva: newValues.partitaiva || '',
  recapiti: newValues._embedded.recapiti.map((obj) => ({ tipo: obj.tipo, nome: obj.nome, key: uuidV4() })),
  domicilioDiversoDaResidenza: newValues._embedded.indirizzi
    ? Boolean(
        _.orderBy(
          newValues._embedded.indirizzi.filter((value) => value.tipo === 'domicilio').toString(),
          ['createdAt'],
          ['asc']
        ).length
      ).toString()
    : 'false', // eslint-disable-line
  anagraficheDisabilitate: newValues.anagraficheDisabilitate,
  'privacy.privacy': true,
  'privacy.marketing': _.get(newValues, 'privacy.consensoMarketing') || false,
  'privacy.profilazione': _.get(newValues, 'privacy.consensoProfilazione') || false,
  'privacy.consensoInvioEmail': _.get(newValues, 'privacy.consensoInvioEmail') || false,
  emailFattura: newValues.emailFattura || '',
  dettaglioProvenienza:
    (provenienzeOptions &&
      _.find(provenienzeOptions.options, (o) => o.value === _.get(newValues, 'dettaglioProvenienza', ''))) ||
    newValues.dettaglioProvenienza ||
    '',
  dettaglioCollaboratore: _.get(newValues, 'dettaglioCollaboratore.id') || '',
  dettaglioCoordinatore: newValues.dettaglioCoordinatore || '',
  dettaglioResponsabileArea: newValues.dettaglioResponsabileArea || '',
  dettaglioInternoKiron: newValues.dettaglioInternoKiron || '',
  provenienzaTecnocasa: newValues.provenienzaTecnocasa || '',
  allegatoPrivacy: newValues.allegatoPrivacy || '',
  allegatoIdentita: _.get(newValues, '_embedded.allegatoIdentita.id')
    ? _.get(newValues, '_embedded.allegatoIdentita.id')
    : '',
  allegatoIdentitaData: _.get(newValues, '_embedded.allegatoIdentita') || {},
  allegatoCodiceFiscale: _.get(newValues, '_embedded.allegatoCodiceFiscale.id')
    ? _.get(newValues, '_embedded.allegatoCodiceFiscale.id')
    : '',
  numeroPratiche: newValues.numeroPratiche,
  note: _.get(newValues, '_embedded.note') || [],
  userAcl: newValues.userAcl || null,
  codiceL3: _.get(newValues, 'userAcl.username'),
  ruoli: _.get(newValues, '_embedded.ruoli') ? newValues._embedded.ruoli : [],
  codicefiscaleForzato: newValues.codicefiscaleForzato || 0,
  disableAcl: false,
  liveIdRequests: newValues.liveIdRequests || [],
  videoRiconosciuto: newValues.videoRiconosciuto || false,
  scadenzaVideoRiconoscimento: newValues.scadenzaVideoRiconoscimento || null,
  moduloIdentificazione: newValues.moduloIdentificazione || null,
  appointment: newValues.appointment ? newValues.appointment : {},
  createdFrom: newValues.createdFrom || 'campus web',
  codiceFiscaleLegaleRappresentante: newValues.codiceFiscaleLegaleRappresentante || null,
  nomeTitolareEffettivo: newValues.nomeTitolareEffettivo || '',
  cognomeTitolareEffettivo: newValues.cognomeTitolareEffettivo || '',
  dataNascitaTitolareEffettivo: newValues.dataNascitaTitolareEffettivo ? moment.unix(newValues.dataNascitaTitolareEffettivo) : '',
  sessoTitolareEffettivo: newValues.sessoTitolareEffettivo || '',
  comuneNascitaTitolareEffettivo: newValues.comuneNascitaTitolareEffettivo || '',
  provinciaNascitaTitolareEffettivo: newValues.provinciaNascitaTitolareEffettivo || '',
  codicefiscaleTitolareEffettivo: newValues.codicefiscaleTitolareEffettivo || '',
  cittaRegistroImprese: newValues.cittaRegistroImprese || '',
  provinciaRegistroImprese: newValues.provinciaRegistroImprese || '',
  numeroRegistroImprese: newValues.numeroRegistroImprese || '',
  allegatoVisuraCamerale: _.get(newValues, '_embedded.allegatoVisuraCamerale.id') || '',
  allegatoIdentitaTitolareEffettivo: _.get(newValues, '_embedded.allegatoIdentitaTitolareEffettivo.id') || '',
  allegatoIdentitaTitolareEffettivoData: _.get(newValues, '_embedded.allegatoIdentitaTitolareEffettivo') || {},
  allegatoCodiceFiscaleTitolareEffettivo: _.get(newValues, '_embedded.allegatoCodiceFiscaleTitolareEffettivo.id') || '',
  allegatoPrivacyTitolareEffettivo: _.get(newValues, '_embedded.allegatoPrivacyTitolareEffettivo.id') || '',
});

export const mapRichiesteImmbiliariToInitialValues = (newValues) => ({
  id: newValues.id,
  collaboratore: newValues.collaboratore || '',
  nome: newValues.nome || '',
  cognome: newValues.cognome || '',
  nominativo: newValues.nominativo || '',
  formaGiuridica: newValues.formaGiuridica || '',
  comuneNascita: newValues.comuneNascita || '',
  ragioneSociale: newValues.ragioneSociale || '',
  sdi: newValues.sdi || '',
  provinciaNascita: newValues.provinciaNascita || '',
  dataNascita: newValues.dataNascita ? moment.unix(newValues.dataNascita) : '',
  sesso: newValues.sesso || '',
  provenienza: {
    dettaglioProvenienzaObbligatoria: newValues._embedded.provenienza
      ? newValues._embedded.provenienza.dettaglioProvenienzaObbligatoria
      : 0,
    provenienzaTecnocasaObbligatoria: newValues._embedded.provenienza
      ? newValues._embedded.provenienza.provenienzaTecnocasaObbligatoria
      : 0,
    value: newValues._embedded.provenienza ? newValues._embedded.provenienza.id : '',
  },
  statoCivile: newValues.statoCivile || '',
  cittadinanza: newValues.cittadinanza ? { value: newValues.cittadinanza, label: newValues.cittadinanza } : '',
  anniInItalia: newValues.anniInItalia || '',
  codicefiscale: newValues.codicefiscale || '',
  indirizzi: newValues._embedded.indirizzi || [],
  partitaiva: newValues.partitaiva || '',
  recapiti: newValues._embedded.recapiti.map((obj) => ({ tipo: obj.tipo, nome: obj.nome, key: uuidV4() })),
  domicilioDiversoDaResidenza: newValues._embedded.indirizzi
    ? Boolean(
        _.orderBy(
          newValues._embedded.indirizzi.filter((value) => value.tipo === 'domicilio').toString(),
          ['createdAt'],
          ['asc']
        ).length
      ).toString()
    : 'false', // eslint-disable-line
  anagraficheDisabilitate: newValues.anagraficheDisabilitate,
  privacy: {
    privacy: true,
    marketing: _.get(newValues, 'privacy.consensoMarketing') || false,
    profilazione: _.get(newValues, 'privacy.consensoProfilazione') || false,
    consensoInvioEmail: _.get(newValues, 'privacy.consensoInvioEmail') || false,
  },
  emailFattura: newValues.emailFattura || '',
  dettaglioProvenienza: newValues.dettaglioProvenienza || '',
  dettaglioCollaboratore: _.get(newValues, 'dettaglioCollaboratore.id') || '',
  dettaglioCoordinatore: newValues.dettaglioCoordinatore || '',
  dettaglioResponsabileArea: newValues.dettaglioResponsabileArea || '',
  dettaglioInternoKiron: newValues.dettaglioInternoKiron || '',
  provenienzaTecnocasa: newValues.provenienzaTecnocasa || '',
  allegatoPrivacy: newValues.allegatoPrivacy || '',
  allegatoIdentita: _.get(newValues, '_embedded.allegatoIdentita.id')
    ? _.get(newValues, '_embedded.allegatoIdentita.id')
    : '',
  allegatoIdentitaData: _.get(newValues, '_embedded.allegatoIdentita') || {},
  allegatoCodiceFiscale: _.get(newValues, '_embedded.allegatoCodiceFiscale.id')
    ? _.get(newValues, '_embedded.allegatoCodiceFiscale.id')
    : '',
  numeroPratiche: newValues.numeroPratiche,
  note: _.get(newValues, '_embedded.note') || [],
});

export default initialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Base/initialValues.js